<script setup>
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    ArcElement
} from 'chart.js'
import { Pie } from 'vue-chartjs'
import { ref, watch } from 'vue'

ChartJS.register(Title, Tooltip, Legend, ArcElement)

const props = defineProps({
    labels: { type: Array, default: () => [] },
    colors: { type: Array, default: () => [] },
    data: { type: Array, default: () => [] },
    title: { type: String, default: '' },
    unit: { type: String, default: '' }
})

const chartRef = ref(null)

const chartData = ref(getChartData())
const options = ref(getChartOptions())

watch(() => props.data, () => {
    chartData.value = getChartData()
}, { immediate: true })

function getChartData() {
    const values = props.data.map(item => item.value)
    const unit = props.data.length > 0 ? props.data[0].unit : props.unit
    return {
        labels: props.labels,
        datasets: [
            {
                label: props.title,
                backgroundColor: props.colors,
                data: values,
                unit
            }
        ]
    }
}

function getChartOptions() {
    return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            tooltip: {
                enabled: true,
                mode: 'single',
                callbacks: {
                    label: function (tooltipItem) {
                        const dataset = tooltipItem.dataset
                        const value = dataset.data[tooltipItem.dataIndex]
                        return `${value} ${dataset.unit || ''}`
                    }
                },
                backgroundColor: 'rgba(255,255,255,0.8)',
                borderColor: 'rgba(0,0,0,0.3)',
                borderWidth: 1,
                bodyFont: {
                    size: 18
                },
                bodyColor: 'rgba(0,0,0,.8)',
                caretSize: 0
            },
            legend: {
                display: true
            }
        }
    }
}

function getChartAsImage() {
    return chartRef.value?.chart.toBase64Image()
}

defineExpose({
    getChartAsImage
})
</script>

<template>
    <div class="nopads" style="height: 100%;">
        <Pie
            ref="chartRef"
            :data="chartData"
            :options="options"
        />
    </div>
</template>
